import ParamSlider from "./paramslider.js";
import ParamTitle from "./paramtitle.js";
import ParamCheckBox from "./paramcheckbox.js";
import "./tabs.css"
import React from "react";

class ApplicationTab extends React.Component
{

    constructor(props)
    {
        super(props);
        this.onchange = this.onchange.bind(this);

        console.log("APPLICATION PARAMS", this.props.applicationsparams)

    }

    componentDidMount()
    {}
    componentWillUnmount()
    {}

    onchange (paramnumber, value)
    {

        
        switch (paramnumber)
        {
            // 100... transcription
            case 100: // taille de la police en treanscription
                this.props.applicationsparams.transcription.initialFontSize = value;
                this.props.onchange({type:"applications", value: this.props.applicationsparams});
                break;
            case 101: // disable popup
                this.props.applicationsparams.transcription.disablePopup = value;
                this.props.onchange({type:"applications", value: this.props.applicationsparams});
                break;
            // 200... sous titrage

            case 200: // affichage tools bar sous le sous-titre
                this.props.applicationsparams.subtitling.displaySubToolsBar = value;
                this.props.onchange({type:"applications", value: this.props.applicationsparams});
                break;

            case 201: // affichage des boutons déplacement mots
                this.props.applicationsparams.subtitling.displayWordsButtons = value;
                this.props.onchange({type:"applications", value: this.props.applicationsparams});
                break;
            case 202: // disable popup
                this.props.applicationsparams.subtitling.disablePopup = value;
                this.props.onchange({type:"applications", value: this.props.applicationsparams});
                break;
        }
    }

    render()
    {
        return(<>
        <div className="tabsettingsFullTab">
            <div className="tabsettingsTitleTab">
                {this.props.title}
                <br/><br/>
            </div>
            <div className="tabsettingscontentdata">
                <ParamTitle
                    text = {{cat:7, scat:24}}
            />
                <ParamSlider 
                    onchange = {this.onchange}
                    paramnumber = {100}
                    key ="sliderFontSize"
                    text ={{cat:7,scat:28}}
                    value = {this.props.applicationsparams.transcription.initialFontSize}
                    min = {12}
                    max ={30}
                    unit = "px" />

                
                <ParamCheckBox
                    onchange = {this.onchange}
                    paramnumber = {101}
                    id = "PL03"
                    text ={{cat:7,scat:32}}
                    value = {this.props.applicationsparams.transcription.disablePopup}
                    />
                <br/>
                <br/>
                
                <ParamTitle
                    text = {{cat:7, scat:25}}
                />

                <ParamCheckBox
                    onchange = {this.onchange}
                    paramnumber = {200}
                    id = "PL01"
                    text ={{cat:7,scat:26}}
                    value = {this.props.applicationsparams.subtitling.displaySubToolsBar}
                    />

                <ParamCheckBox
                    onchange = {this.onchange}
                    paramnumber = {201}
                    id = "PL02"
                    text ={{cat:7,scat:27}}
                    value = {this.props.applicationsparams.subtitling.displayWordsButtons}
                    />

                <ParamCheckBox
                    onchange = {this.onchange}
                    paramnumber = {202}
                    id = "PL04"
                    text ={{cat:7,scat:32}}
                    value = {this.props.applicationsparams.subtitling.disablePopup}
                    />
                <br/>

            </div>

            
        </div>
        </>
        )
    }

}

export default ApplicationTab